import React, {useState, useEffect} from "react";
// import config from "../../../config";
import client from "../../../clients";
import { isAuthenticated } from "../../../auth";
import { addDaysOnMembership } from "../helper/api";
import Toast from "../../../lib/toast";

const AddOnDays = (props) => {

  const membership = props.membership;
  const [currentElementId, setCurrentElementId] = useState("");
  const [addOnDay, setAddOnDay] = useState("");
  const {user,token} = isAuthenticated();
  const [isButtonLock,setButtonLock] = useState(true);
  const [reason,setReason] = useState('')
 
  const AddDaysToMembership = async event =>{
    setButtonLock(true);
    try{
      const payload = {
        addOnDay,
        reason
      };


      const response = await addDaysOnMembership(user._id,token,membership._id,payload);

      if(response.error){
        new Toast({
          type:'error',
          message:response.error,
          duration:3000
        });
      }else{

        new Toast({
          type:'success',
          message:"Membership updated",
          duration:3000
        });

        props.reload();
        props.toggleModalType()

      }




    }catch(error){

    }
    setButtonLock(false);

  }

  const toggleInputFields = (id) => event => {
    setCurrentElementId(id);
    if (event) {
      let interval = setInterval(() => {
        let element = document.getElementById(id) ? document.getElementById(id) : event.target.querySelector('input');
        if (element) {
          element.focus();
          clearInterval(interval)
        }
      }, 0);
    }
  }

  const handleChange = (event) => {
    setAddOnDay(event.target.value)
  }

  const handleChangeReason = event => setReason(event.target.value);

  useEffect(()=>{
    setButtonLock(addOnDay?false:true);
  },[addOnDay])

  if(!membership) return <></>

  return(
    <div className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`}>
      <div className={`${window.innerWidth > 767 ? "fitness-test-modal flex-item" : "w-full h-full"}`} style={{height:window.innerWidth > 767 && 'auto'}}>
        {
          window.innerWidth > 767 && (
            <div className="d-flex w-full space-between" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0"}}>
              <div className='d-flex'>
                <svg className='flex-item m-r-12' width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.25 3.7525C15.6625 3.75083 15.0375 3.75 14.375 3.75C8.7775 3.75 5.9775 3.75 4.23875 5.48875C2.5 7.2275 2.5 10.0262 2.5 15.625C2.5 21.2225 2.5 24.0225 4.23875 25.7612C5.9775 27.5 8.77625 27.5 14.375 27.5C19.9725 27.5 22.7725 27.5 24.5112 25.7612C26.25 24.0225 26.25 21.2238 26.25 15.625C26.25 14.9625 26.2492 14.3375 26.2475 13.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M8.75 21.875C11.665 18.8225 17.0537 18.6788 20 21.875M23.125 2.5L23.4475 3.37125C23.87 4.51375 24.0812 5.085 24.4975 5.50125C24.915 5.91875 25.4862 6.13 26.6287 6.5525L27.5 6.875L26.6287 7.1975C25.4862 7.62 24.915 7.83125 24.4988 8.2475C24.0813 8.665 23.87 9.23625 23.4475 10.3788L23.125 11.25L22.8025 10.3788C22.38 9.23625 22.1688 8.665 21.7525 8.24875C21.335 7.83125 20.7637 7.62 19.6212 7.1975L18.75 6.875L19.6212 6.5525C20.7637 6.13 21.335 5.91875 21.7512 5.5025C22.1687 5.085 22.38 4.51375 22.8025 3.37125L23.125 2.5ZM17.4937 12.5C17.4937 14.225 16.0937 15.625 14.365 15.625C13.9542 15.6257 13.5473 15.5453 13.1676 15.3886C12.7879 15.2318 12.4428 15.0017 12.1521 14.7115C11.8613 14.4212 11.6307 14.0765 11.4734 13.697C11.316 13.3176 11.235 12.9108 11.235 12.5C11.235 10.775 12.635 9.375 14.365 9.375C14.7757 9.37451 15.1825 9.45497 15.562 9.6118C15.9416 9.76862 16.2866 9.99873 16.5771 10.289C16.8677 10.5792 17.0982 10.9239 17.2555 11.3032C17.4128 11.6826 17.4938 12.0893 17.4937 12.5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p className="flex-item fs-18 color-white font-weight-600">Membership</p>
              </div>
              <div onClick={()=>props.toggleModalType()} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )
        }
        <div className='w-full' style={{padding:"12px", height: "90%", overflowY:"auto"}}>
          <div className="d-flex" style={{background:"#ffffff", padding:"8px 12px", borderRadius:"12px"}}>
            {/* <div className="table-item-profile d-flex flex-item">
              <img className="flex-item" src={'https://picsum.photos/id/1/200/300'} />
            </div> */}
            {
              membership.user.length && (
                membership.user[0].profileID?(
                  <div className="table-item-profile d-flex flex-item">
                    <img className="flex-item" src={`${client.config.API_URL}/image/file/${membership.user[0].profileID}/30/30/70?${Date.now()}`} />
                  </div>
                ):(
                  <div className='table-item-profile d-flex flex-item' style={{
                    backgroundColor: "#5d883c"
                  }}>
                    <p className='flex-item' style={{
                      color: "#ffffff",
                      margin: "0 auto",
                      fontSize: 14,
                    }}>{`${membership.user[0].name}`.trim()[0]}</p>
                  </div>
                )
              )
            }
            <div className="flex-item m-l-8">
              <p className="color-black fs-16 font-weight-600" style={{lineHeight:"16px"}}>{membership.user.length && membership.user[0].name}</p>
              <p className="color-grey-02 fs-12 m-t-6" style={{lineHeight:"10px"}}>{membership.user.length && membership.user[0].phone}</p>
            </div>
          </div>
          <div className="flex-item m-t-16">
            <p className="fs-12 font-weight-600 color-dark-blue m-b-2" style={{lineHeight:"12px"}}>Membership ID</p>
            <p className="font-weight-700">{membership.membershipDisplayNumber}</p>
          </div>
          <div onClick={toggleInputFields('add-on')} className={`${(currentElementId == 'add-on' || addOnDay) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-t-12`} style={{ border: (currentElementId == 'add-on' || addOnDay) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
            <div className="flex-item d-flex">
              <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'add-on' || addOnDay) ? "10px" : "14px", color: (currentElementId == 'add-on' || addOnDay) ? "var(--darkBlue)" : "", transition: "180ms" }}>Add On Days *</p>
            </div>
            <input id="add-on" value={addOnDay} onChange={handleChange} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'add-on' || addOnDay) ? "active-input-field" : "inactive-input-field"}`} type="number" />
          </div>
           <div onClick={toggleInputFields('reason')} className={`${(currentElementId == 'reason' || reason) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-t-12`} style={{ border: (currentElementId == 'reason' || reason) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
            <div className="flex-item d-flex">
              <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'reason' || reason) ? "10px" : "14px", color: (currentElementId == 'reason' || reason) ? "var(--darkBlue)" : "", transition: "180ms" }}>Reason *</p>
            </div>
            <input id="reason" value={reason} onChange={handleChangeReason} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'reason' || reason) ? "active-input-field" : "inactive-input-field"}`} type="text" />
          </div>
          <svg className="m-t-16 m-b-16" width="100%" height="4" viewBox="0 0 375 2" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="-0.00585938" y1="1.00391" x2="375.006" y2="1.00391" stroke="#A5A5A5" stroke-dasharray="2 2"/>
          </svg>
          <div className="d-flex">
            <p className="flex-item font-weight-700 color-red m-r-20">Add On By</p>
            <p className="flex-item font-weight-700 color-black">{user.name}</p>
          </div>
          <div onClick={isButtonLock?null:AddDaysToMembership} className={`global-button-container ${isButtonLock?"global-button-container-inactive":"global-button-container-active"} m-t-26 d-flex flex-item m-b-0`} style={{borderRadius:"20px", height:"40px",pointerEvents:isButtonLock?'none':'auto'}}>
            <p className="flex-item">Update Add On Days</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddOnDays;